export class SpeechFilter {

  private readonly _filters: Record<string, BaseFilter[]> = {};

  constructor(entity) {
    for (const [key, value] of Object.entries(entity)) {
      this._filters[key] = [];
      for (const f of value as BaseFilter[]) {
        this._filters[key].push(new BaseFilter(f));
      }
    }
    for (const [key, value] of Object.entries(this._filters)) {
      value.sort(((a, b) => {
        return a.sortOrder.localeCompare(b.sortOrder)
      }));
    }
  }


  get filters(): Record<string, BaseFilter[]> {
    return this._filters;
  }
  filterExists(): boolean {
    return JSON.stringify(this._filters) !== '{}'
  }
}


export class BaseFilter {
  private readonly _id: string;
  private readonly _title: string;
  private readonly _sortOrder: string;


  constructor(entity) {
    this._title = entity.title;
    this._id = entity.id;
    this._sortOrder = entity.s_order;
  }


  get id(): string {
    return this._id;
  }

  get title(): string {
    return this._title;
  }

  get sortOrder(): string {
    return this._sortOrder;
  }
}
